import { Navigate, Route, Routes, useParams } from "react-router-dom";
import ClientPortalShell from "./ClientPortalShell";
import { PortalProvider } from "./PortalContext";
import PortalAccount from "./PortalAccount";
import PortalEvaluations from "./PortalEvaluations";
import PortalHome from "./PortalHome";
import PortalNewRequest from "./PortalNewRequest";
import PortalTeam from "./PortalTeam";

const PortalRoutes = ({ base }) => (
  <Routes>
    <Route element={<ClientPortalShell base={base} />}>
      <Route index element={<PortalHome base={base} />} />
      <Route path="evaluations" element={<PortalEvaluations />} />
      <Route path="team" element={<PortalTeam />} />
      <Route path="new-request" element={<PortalNewRequest base={base} />} />
      <Route path="account" element={<PortalAccount />} />
      <Route path="*" element={<Navigate to={base} replace />} />
    </Route>
  </Routes>
);

// Client users land here (/portal). TAG admins open /client-portal-preview/:clientId to see the same screens as that client.
export default function ClientPortalApp() {
  return (
    <PortalProvider>
      <PortalRoutes base="/portal" />
    </PortalProvider>
  );
}

export function ClientPortalPreviewApp() {
  const { clientId } = useParams();
  return (
    <PortalProvider key={clientId} previewClientId={clientId}>
      <PortalRoutes base={`/client-portal-preview/${clientId}`} />
    </PortalProvider>
  );
}
